"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SVGIcon = _interopRequireDefault(require("./SVGIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const BackIcon = (0, _styledComponents.default)(_SVGIcon.default).withConfig({
  displayName: "ViewHeader__BackIcon",
  componentId: "sc-4dbkib-0"
})(["margin-left:-16px;"]);

const ViewHeader = ({
  className,
  children,
  onBack
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: className
}, onBack && /*#__PURE__*/_react.default.createElement(BackIcon, {
  name: "arrowLeft",
  color: "333",
  onClick: onBack
}), children);

var _default = (0, _styledComponents.default)(ViewHeader).withConfig({
  displayName: "ViewHeader",
  componentId: "sc-4dbkib-1"
})(["flex-shrink:0;align-items:center;border-bottom:1px solid #dfdfdf;display:flex;padding:0 16px;h1{font-size:24px;font-weight:300;flex:1;}"]);

exports.default = _default;